import { create } from 'zustand';

const STORAGE_PREFIX = 'wf-active-workspace:';

interface WorkspaceState {
  activeWorkspaceId: string | null;
  setActiveWorkspaceId: (userId: string, workspaceId: string) => void;
  loadForUser: (userId: string) => void;
  reset: () => void;
}

// Persisted per-user (not a single global key) since a browser profile can
// sign in as different users over time (§15.2).
export const useWorkspaceStore = create<WorkspaceState>()((set) => ({
  activeWorkspaceId: null,
  setActiveWorkspaceId: (userId, workspaceId) => {
    localStorage.setItem(STORAGE_PREFIX + userId, workspaceId);
    set({ activeWorkspaceId: workspaceId });
  },
  loadForUser: (userId) => {
    set({ activeWorkspaceId: localStorage.getItem(STORAGE_PREFIX + userId) });
  },
  // Cleared on every account change (lib/auth-reset.ts) so the previous user's
  // workspace id can't reach the API under the new user's token.
  reset: () => {
    set({ activeWorkspaceId: null });
  },
}));
